import * as z from 'zod/mini';
import { GlobalOptionsSchema } from './global';

export const BookingFlowOptions = z.object({
  ...GlobalOptionsSchema,
  packageId: z.number(),
  date: z.string(),
  pax: z.number(),
  calendarStepUrl: z.nullish(z.string()),
  thanksPageUrl: z.nullish(z.string()),
  mandatoryFields: z.nullish(z.string()),
  passportFields: z.pipe(
    z.nullish(z.enum(['true', 'false'])),
    z.transform((value) => value === 'true'),
  ),
});
